import type { MetaDefinition } from "@angular/platform-browser"

interface ISEO {
  TITLE: string
  SITE_NAME: string
  DESCRIPTION: string
  AUTHOR: string
  BASE_URL: string
  KEYWORDS: string[]
}

export const SEO: ISEO = {
  TITLE: 'Nolia',
  SITE_NAME: 'Nolia',
  // Tagline del manual de marca §03 (versión "con tagline" del logotipo).
  DESCRIPTION: 'La nueva era de la orientación vocacional.',
  AUTHOR: 'Nolia',
  // La web es noliaedu.com; la app va a un subdominio todavía sin definir.
  BASE_URL: 'https://noliaedu.com',
  KEYWORDS: ['Nolia', 'orientación vocacional']
}

// SEO by Page
export const SEO_TAGS_COMMON: MetaDefinition[] = [
  { name: 'keywords', content: SEO.KEYWORDS.join(', ') },
  { name: 'author', content: SEO.TITLE },
]

export const SEO_TAGS_HIDDEN_PAGE: MetaDefinition[] = [
  { name: 'robots', content: 'noindex' },
  { name: 'robots', content: 'nofollow' },
]

// Public Pages
export const SEO_TAGS_SIGN_IN_PAGE: MetaDefinition[] = [
  ...SEO_TAGS_COMMON,
  { name: 'description', content: `Iniciar sesión en ${ SEO.TITLE }` },
]

export const SEO_TAGS_RECOVERY_ACCOUNT_PAGE: MetaDefinition[] = [
  ...SEO_TAGS_COMMON,
  { name: 'description', content: `Recuperar cuenta en ${ SEO.TITLE }` },
]

export const SEO_TAGS_PASSWORD_RESET_PAGE: MetaDefinition[] = [
  ...SEO_TAGS_COMMON,
  { name: 'description', content: `Resetear contraseña en ${ SEO.TITLE }` },
]

export const SEO_TAGS_TERMS_PAGE: MetaDefinition[] = [
  ...SEO_TAGS_COMMON,
  { name: 'description', content: `Terminos y condiciónes en ${ SEO.TITLE }` },
]